import axios from 'axios'

const typeBaseURL = process.env.VUE_APP_BACKEND_BASEURL
const isProd = typeBaseURL === 'production'
const isLocal = typeBaseURL === 'local'

const baseUrl = () => {
  if (isProd) {
    return process.env.VUE_APP_BACKEND_BASEURL_PRODUCTION
  }

  if (isLocal) {
    return process.env.VUE_APP_BACKEND_BASEURL_LOCAL
  }
}

const api = axios.create({
  baseURL: baseUrl(),
})

export default api
